module.exports = __webpack_public_path__ + "media/src/assets/images/sale-ai_graph1_2-542ed47bd3478cb2abf172bfbd243d5a.png";